import React from 'react';

import COLORS from '@mlb/react-patterns/style/universal.color';

import FilterButton from '../FilterButton';

const Default = (props) => (
    <FilterButton
        iconName={'filter'}
        iconColor={COLORS.linkBlueOnDark}
        labelKey={'filters'}
        iconLeft={false}
        shape={'hollow'}
        styleName={'default'}
        {...props}
    />
);

export default Default;
